import * as React from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '@/utils/cn';

const inputVariants = cva(
  'block h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm text-foreground shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:text-muted-foreground disabled:opacity-50',
  {
    variants: {
      variant: {
        default: '',
        borderLess: 'border-0 bg-transparent px-0 shadow-none ring-0',
        danger:
          'border-red-500 text-red-500 placeholder:text-red-300 focus-visible:ring-red-500'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {
  icon?: React.ReactNode;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ variant, className, children, icon, ...props }, ref) => {
    return (
      <div className="relative w-full">
        {icon && (
          <div className="text-primary-500 pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            {icon}
          </div>
        )}
        <input
          ref={ref}
          className={cn(
            inputVariants({ variant }),
            icon ? 'pl-11' : '',
            className
          )}
          {...props}
        >
          {children}
        </input>
      </div>
    );
  }
);
Input.displayName = 'Input';
